module.exports = __webpack_public_path__ + "img/chevrons-right.28828b2b.svg";